// Reports:
// Storage
import Storage from "../pages/reports/Storage/Storage";
import EnterpriseHealth from "../pages/reports/Storage/EnterpriseHealth";
import EnterpriseHealthAlerts from "../pages/reports/Storage/EnterpriseHealthAlerts";
import EnterprisePerformance from "../pages/reports/Storage/EnterprisePerformance";
import EnterpriseSummary from "../pages/reports/Storage/EnterpriseSummary";
import EnterpriseTrends from "../pages/reports/Storage/EnterpriseTrends";
import AllUnits from "../pages/reports/Storage/AllUnits";
import StorageEnvironment from "../pages/reports/Storage/StorageEnvironment";
import StorageByBu from "../pages/reports/Storage/StorageByBu";
import FreeSpaceBy from "../pages/reports/Storage/FreeSpaceBy";
import DiskTypeBy from "../pages/reports/Storage/DiskTypeBy";
import EnterpriseSnap from "../pages/reports/Storage/EnterpriseSnap";
import StorageHostDeviceCapacityModeling from "../pages/reports/Hosts/StorageHostDeviceCapacityModeling";
import EnterpriseCapacityPlan from "../pages/reports/Storage/EnterpriseCapacityPlan";

// Storage/Device
import DeviceSummaryV2 from "../pages/reports/Storage/Device/DeviceSummaryV2";
import DeviceHealth from "../pages/reports/Storage/Device/DeviceHealth";
import DeviceAdditionalDetails from "../pages/reports/Storage/Device/DeviceAdditionalDetails";
import AuditReport from "../pages/reports/Storage/Device/AuditReport";
import PhysicalDiagram from "../pages/reports/Storage/Device/PhysicalDiagram";
import StorageGroupSummary from "../pages/reports/Storage/Device/StorageGroupSummary";
import StorageServerType from "../pages/reports/Storage/Device/StorageByServerByType";
import FreeSpaceByDiskByType from "../pages/reports/Storage/Device/FreeSpaceByDiskByType";
import DeviceTrends from "../pages/reports/Storage/Device/DeviceTrends";
import DeviceCapacityPlan from "../pages/reports/Storage/Device/DeviceCapacityPlan";
import PoolCapacityPlan from "../pages/reports/Storage/Device/PoolCapacityPlanning";
import ProvisioningReport from "../pages/reports/Storage/Device/ProvisioningReport";

// BU / Executive Reports
import ExecutiveReports from "../pages/reports/ExecutiveReports/ExecutiveReports";
import EndOfSupportCalendar from "../pages/reports/ExecutiveReports/EndOfSupportCalendar";
import ITDashboard from "../pages/reports/ExecutiveReports/ITDashboard";
import BUTrends from "../pages/reports/ExecutiveReports/BUTrends";
import BUExecutiveOverview from "../pages/reports/ExecutiveReports/BUExecutiveOverview";
import ForecastSummary from "../pages/reports/ExecutiveReports/ForecastSummary";
import InventoryReport from "../pages/reports/ExecutiveReports/InventoryReport";

// FinOps
import FinOpsReports from "../pages/reports/FinOps/FinOpsReports";
import SavingsReport from "../pages/reports/FinOps/SavingsReport";
import BUChargebackReport from "../pages/reports/FinOps/BUChargeback";

// Hosts
import Hosts from "../pages/reports/Hosts/Hosts";
import EntHostSummary from "../pages/reports/Hosts/HostSummary";
import HostConnectedSwitches from "../pages/reports/Hosts/Host/HostConnectedSwitches";
import HostTrends from "../pages/reports/Hosts/Host/HostTrends";
import HostLunPerformanceDetail from "../pages/reports/Hosts/Host/HostLunPerformanceDetail";
import HostLunList from "../pages/reports/Hosts/HostLunList";

// File Analysis
import Files from "../pages/reports/Files/Files";
import FileSavings from "../pages/reports/Files/FileSavings";
import FileTrends from "../pages/reports/Files/FileTrends";
import FilesByLastUsed from "../pages/reports/Files/FilesByLastUsed";

// Virtual (VMware)
import Virtual from "../pages/reports/Virtual/Virtual";
import VirtualSummary from "../pages/reports/Virtual/VirtualSummary";
import VirtualAllUnits from "../pages/reports/Virtual/AllUnits";
import VirtualHealthAlerts from "../pages/reports/Virtual/VirtualHealthAlerts";
import VirtualTrends2 from "../pages/reports/Virtual/VirtualTrends2";
import VirtualEnvironment from "../pages/reports/Virtual/VirtualEnvironment";
import VirtualOrphanedVMDKs from "../pages/reports/Virtual/VirtualOrphanedVMDKs";
import VirtualDatastoreMapping from "../pages/reports/Virtual/VirtualDatastoreMapping";
import VirtualPlanningSummary from "../pages/reports/Virtual/VirtualPlanningSummary";
import ClusterMigrationModeler from "../pages/reports/Virtual/Cluster/ClusterMigrationModeler";

// Virtual/Clusters
import ClusterTrends from "../pages/reports/Virtual/Cluster/ClusterTrends";
import ClusterSummary from "../pages/reports/Virtual/Cluster/ClusterSummary";
import ClusterModeling from "../pages/reports/Virtual/Cluster/ClusterModeling";

// Virtual/Datastores
import DatastoreSummary from "../pages/reports/Virtual/Datastore/DatastoreSummary";

// Virtual/Hosts
import VirtualHostSummary from "../pages/reports/Virtual/Hosts/VirtualHostSummary";
import DatastoreCapacityHistory from "../pages/reports/Virtual/Hosts/DatastoreCapacityHistory";

// Virtual/VMs
import VMSummary from "../pages/reports/Virtual/VM/VMSummary";

// Virtual/Vcenter
import DataCenterSummary from "../pages/reports/Virtual/VCenter/DataCenterSummary";
import DeltaReport from "../pages/reports/Virtual/DeltaReport";

// Backup
import Backup from "../pages/reports/Backup/Backup";
import BackupRuntime from "../pages/reports/Backup/BackupRuntime";
import BackupStatus from "../pages/reports/Backup/BackupStatus";
import BackupGapAnalysis from "../pages/reports/Backup/BackupGapAnalysis";
import BackupTrend from "../pages/reports/Backup/BackupTrend";
import BackupPoolSummary from "../pages/reports/Backup/BackupPoolSummary";
import BackupPoolTrend from "../pages/reports/Backup/BackupPoolTrend";
import BackupHostOccupancy from "../pages/reports/Backup/BackupHostOccupancy";
import BackupVmAuditReport from "../pages/reports/Backup/BackupVmAuditReport";

// Switches
import Switches from "../pages/reports/Switches/Switches";
import SwitchesSummary from "../pages/reports/Switches/SwitchesSummary";
import SanPortErrorTrend from "../pages/reports/Switches/Switch/SanPortErrorTrend";
import ISLPortAnalysis from "../pages/reports/Switches/Switch/ISLPortAnalysis";
import SwitchTopology from "../pages/reports/Switches/SwitchTopology";
import SwitchSummary from "../pages/reports/Switches/Switch/SwitchSummary";
import EnterpriseSwitchHealthAlerts from "../pages/reports/Switches/EnterpriseSwitchHealthAlerts";
import SwitchZoneDetail from "../pages/reports/Switches/Switch/ZoneDetail";
import SANPortDetail from "../pages/reports/Switches/Switch/SANPortDetail";
import PortConnectivity from "../pages/reports/Switches/Switch/PortConnectivity";

// Database
import Databases from "../pages/reports/Databases/Databases";
import DatabaseVersions from "../pages/reports/Databases/DatabaseVersions";
import DatabaseServerCapacityPlan from "../pages/reports/Databases/Server/DatabaseServerCapacityPlan";
import DatabaseServerTrend from "../pages/reports/Databases/Server/DatabaseServerTrend";
import EnterpriseDatabaseSummary from "../pages/reports/Databases/EnterpriseDatabaseSummary";
import DatabaseInstances from "../pages/reports/Databases/DatabaseInstances";
import DatabaseIntanceDetail from "../pages/reports/Databases/Server/DatabaseInstanceDetail";
import DatabaseHealthAlerts from "../pages/reports/Databases/DatabaseHealthAlerts";
import DatabaseMissingIndexes from "../pages/reports/Databases/DatabaseMissingIndexes";
import DatabaseUnusedIndexes from "../pages/reports/Databases/DatabaseUnusedIndexes";

//Cloud
import Cloud from "../pages/reports/Cloud/Cloud";
import CloudBudgetTrend from "../pages/reports/Cloud/CloudBudgetTrend";
import CloudTrends from "../pages/reports/Cloud/CloudTrends";
import CloudGrowthOverview from "../pages/reports/Cloud/CloudGrowthOverview";
import CloudResourceGroupForecast from "../pages/reports/Cloud/CloudResourceGroupForecast";
import CloudResourceModeling from "../pages/reports/Cloud/CloudResourceModeling";
import CloudHealthAlerts from "../pages/reports/Cloud/CloudHealthAlerts";
import CloudCostReport from "../pages/reports/Cloud/CloudCostReport";
import CloudStorageByGroup from "../pages/reports/Cloud/CloudStorageByGroup";
import CloudSummary from "../pages/reports/Cloud/CloudSummary";
import CloudAllUnits from "../pages/reports/Cloud/CloudAllUnits";

// Kubernetes:
import KubernetesClusterOverview from "../pages/reports/Kubernetes/Cluster/KubernetesClusterOverview";
import Kubernetes from "../pages/reports/Kubernetes/Kubernetes";
import KubernetesAllUnits from "../pages/reports/Kubernetes/KubernetesAllUnits";
import KubernetesNodeStatus from "../pages/reports/Kubernetes/Node/KubernetesNodeStatus";
import KubernetesBudgetingReport from "../pages/reports/Kubernetes/KubernetesBudgetingReport";
import KubernetesCapacityPlan from "../pages/reports/Kubernetes/KubernetesCapacityPlan";

// User:
import Profile from "../pages/user/Profile";
import Settings from "../pages/user/Settings";
import Uploads from "../pages/user/Uploads";
import CollectionStatus from "../pages/user/CollectionStatus";
import AllUploads from "../pages/admin/AllUploads";
import Tagging from "../pages/user/Tagging";

// Admin:
import Clients from "../pages/admin/Clients";
import Users from "../pages/admin/Users";
import AddUser from "../pages/admin/AddUser";
import EditUser from "../pages/admin/EditUser";
import AddCollectionDevice from "../pages/admin/AddCollectionDevice";
import CollectionDevices from "../pages/admin/CollectionDevices";
import AllDevicesAllClients from "../pages/admin/AllDevicesAllClients";
import Sessions from "../pages/admin/Sessions";
import Services from "../pages/admin/Services";
import DevicesParserControl from "../pages/admin/DevicesParserControl";
import AutobotConfirmation from "../pages/admin/AutobotConfirmation";
import DataIntegrityReport from "../pages/admin/DataIntegrityReport";

// Security:
import SecurityDashboard from "../pages/reports/Security/SecurityDashboard";
import Security from "../pages/reports/Security/Security";
import AdministrativeReport from "../pages/reports/Security/AdministrativeReport";

// Misc
import Home from "../pages/Home";
import PlanningProjects from "../pages/reports/Storage/PlanningProjects";
import Sandbox from "../components/Sandbox";
import DatabaseQueriesPerformance from "../pages/reports/Databases/DatabaseQueriesPerformance";
import DatabaseFragmentation from "../pages/reports/Databases/DatabaseFragmentation";
import OperatingCost from "../pages/user/OperatingCost";

export const staticDateReliantReportContexts = ["Server", "Backup", "Switch", "SAN-Switch", "Datastore", "VM", "Hosts", "Host", "File", "Files", "Business Unit", "Storage", "Virtual", "Security", "FinOps", "Cloud", "Kubernetes", "Sandbox", "Device", "ESX Host", "Cluster", "Data Center"];


export const drillDownItems = [
    {
        context: "Admin",
        title: "Add User",
        icon: "fa-solid fa-user",
        path: "/user/settings/admin/users/add-user",
        isAdmin: true,
        Component: AddUser,
    },
    {
        context: "Admin",
        title: "Edit User",
        icon: "fa-solid fa-user",
        path: "/user/settings/admin/users/edit-user",
        isAdmin: true,
        Component: EditUser,
    },
    {
        context: "Admin",
        title: "Add Collection Device",
        icon: "fa-solid fa-user",
        path: "/user/settings/collection-devices/add-collection-device",
        isAdmin: true,
        Component: AddCollectionDevice,
    },
    {
        context: "Sandbox",
        title: "Sandbox",
        icon: "fa-solid fa-user",
        path: "/sandbox/sandbox-1",
        roles: ["super_user", "super_user_read_only"],
        Component: Sandbox,
    },
];

export const utilItems = [
    {
        context: "Settings",
        title: "Profile",
        icon: "fa-solid fa-user",
        path: "/user/profile",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Profile,
    },
    {
        context: "Settings",
        title: "Settings",
        icon: "fa-solid fa-gears",
        path: "/user/settings",
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: Settings,
    },
    {
        context: "Admin",
        title: "Clients",
        icon: "fa-solid fa-heart",
        path: "/admin/clients",
        roles: ["super_user", "super_user_read_only"],
        isAdmin: true,
        Component: Clients,
    },
];

export const settingsItems = [
    {
        context: "Settings",
        title: "Uploads",
        icon: "fa-solid fa-cloud-arrow-up",
        path: "/user/settings/uploads",
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: Uploads,
    },
    {
        context: "Settings",
        title: "Tagging",
        icon: "fa-solid fa-tag",
        path: "/user/settings/tagging",
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: Tagging,
    },
    {
        context: "Settings",
        title: "Collection Devices",
        icon: "fa-solid fa-cloud-arrow-up",
        path: "/user/settings/collection-devices",
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: CollectionDevices,
    },
    {
        context: "Settings",
        title: "Operating Cost",
        icon: "fa-solid fa-chart-line",
        path: "/user/settings/operating-cost",
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: OperatingCost,
    }
];

export const adminItems = [
    {
        context: "Admin",
        title: "All Uploads",
        icon: "fa-solid fa-cloud-arrow-up",
        path: "/user/settings/admin/all-uploads",
        roles: ["super_user", "super_user_read_only"],
        Component: AllUploads,
    },
    {
        context: "Admin",
        title: "All Clients",
        icon: "fa-solid fa-heart",
        path: "/user/settings/admin/all-clients",
        roles: ["super_user", "super_user_read_only"],
        isAdmin: true,
        Component: Clients,
    },
    {
        context: "Admin",
        title: "Users",
        icon: "fa-solid fa-users",
        path: "/user/settings/admin/client-users",
        roles: ["local_admin"],
        isAdmin: true,
        Component: Users,
    },
    {
        context: "Admin",
        title: "All Users",
        icon: "fa-solid fa-users",
        path: "/user/settings/admin/users",
        roles: ["super_user", "super_user_read_only"],
        isAdmin: true,
        Component: Users,
    },
    {
        context: "Admin",
        title: "All Sessions",
        icon: "fa-sharp fa-solid fa-user-clock",
        path: "/user/settings/admin/all-sessions",
        roles: ["super_user", "super_user_read_only"],
        Component: Sessions
    },
    {
        context: "Admin",
        title: "All Devices / All Clients",
        icon: "fa-sharp fa-solid fa-user-clock",
        path: "/user/settings/admin/all-devices-all-clients",
        roles: ["super_user", "super_user_read_only"],
        Component: AllDevicesAllClients
    },
    {
        context: "Admin",
        title: "Registered Services",
        icon: "fas fa-plug",
        path: "/user/settings/admin/services",
        roles: ["super_user", "super_user_read_only"],
        Component: Services
    },
    {
        context: "Admin",
        title: "Devices Parser Control",
        icon: "fas fa-plug",
        path: "/user/settings/admin/device-parser-control",
        roles: ["super_user", "super_user_read_only"],
        Component: DevicesParserControl
    },
    {
        context: "Admin",
        title: "Data Integrity",
        icon: "fas fa-ribbon",
        path: "/user/settings/admin/data-integrity",
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: DataIntegrityReport
    },
];

export const autobotItems = [
    {
        context: "Admin",
        title: "Autobot Confirmation",
        icon: "fas fa-plug",
        path: "/user/settings/admin/autobot",
        Component: AutobotConfirmation
    },
]

export const buItems = [
    {
        context: "Business Unit",
        title: "Executive Overview",

        icon: "fa-chart-pie",
        path: "/reports/business-unit/executive-overview",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Executive Overview",
                description: "View Business Unit Executive Overview."
            }
        ],
        Component: BUExecutiveOverview,
    },
    {
        context: "Business Unit",
        title: "IT Dashboard",
        path: "/reports/business-unit/it-dashboard",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "IT Dashboard",
                description: "View Storage or Servers at or approaching threshold."
            }
        ],
        Component: ITDashboard,
    },
    {
        context: "Business Unit",
        title: "End of Support Calendar",
        path: "/reports/business-unit/end-of-support-calendar",
        icon: "fa-calendar-range",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "End of Support Calendar",
                description: "See devices charted from the time they were purchased to when they will reach the end of their maintenance schedule."
            }
        ],
        Component: EndOfSupportCalendar,
    },
    {
        context: "Business Unit",
        title: "Business Unit Trends",
        path: "/reports/business-unit/trends",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Business Unit Trends",
                description: "See trends based on defined business units."
            }
        ],
        Component: BUTrends,
    },
    {
        context: "Business Unit",
        title: "Forecast Summary",
        path: "/reports/business-unit/forecast-summary",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Forecast Summary",
                description: "See pools and clusters forecasted to exceed thresholds."
            }
        ],
        Component: ForecastSummary,
    },
    {
        context: "Business Unit",
        title: "Inventory Report",
        path: "/reports/business-unit/inventory-report",
        icon: "fa-chart-tree-map",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Inventory Report",
                description: "View an overview of storage or virtual space."
            }
        ],
        Component: InventoryReport,
    },
];

export const finOpsItems = [
    {
        context: "FinOps",
        title: "Savings Report",
        path: "/reports/finops/savings-report",
        icon: "fa-chart-column",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Savings Report",
                description: "View an overview of potential savings for various contexts."
            }
        ],
        Component: SavingsReport,
    },
    {
        context: "FinOps",
        title: "Chargeback Report",
        icon: "fa-chart-bar",
        path: "/reports/finops/chargeback",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Chargeback Report",
                description: "View Business Unit Chargeback Report."
            }
        ],
        Component: BUChargebackReport,
    },
];

export const storageItems = [
    {
        context: "Storage",
        title: "Enterprise Summary",
        path: "/reports/storage/enterprise-summary",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Enterprise Storage Summary",
                description: "View high-level summary of enterprise information."
            }
        ],
        Component: EnterpriseSummary,
        icon: "fa-chart-user",
    },
    {
        context: "Storage",
        title: "All Units",
        path: "/reports/storage/all-units",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View all units of the storage device. All devices, pools, volumes, LUNs, shares, and nodes."
            },
        ],
        Component: AllUnits,
        icon: "fa-table",
    },
    {
        context: "Storage",
        title: "Storage Environment",
        path: "/reports/storage/storage-environment",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View a top level overview of your storage environment."
            },
        ],
        Component: StorageEnvironment,
        icon: "fa-chart-tree-map",
    },
    {
        context: "Storage",
        title: "Trends",
        path: "/reports/storage/enterprise-trends",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View all Enterprise Trends including capacity and performance at the data center, device type, and classification levels."
            },
        ],
        Component: EnterpriseTrends,
    },
    {
        context: "Storage",
        title: "Health Report",
        path: "/reports/storage/enterprise-health",
        icon: "fa-monitor-waveform",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View all Enterprise Health Alerts in grid format."
            },
        ],
        Component: EnterpriseHealth,
    },
    {
        context: "Storage",
        title: "Health Alerts",
        path: "/reports/storage/enterprise-alerts",
        icon: "fa-monitor-waveform",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View yellow and red Enterprise Health Alerts in grid format."
            },
        ],
        Component: EnterpriseHealthAlerts,
    },
    {
        context: "Storage",
        title: "Delta Report",
        path: "/reports/storage/enterprise-performance",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View monthly Enterprise performance in grid format."
            },
        ],
        Component: EnterprisePerformance,
        icon: "fa-chart-column",
    },
    {
        context: "Storage",
        title: "Storage by Group",
        path: "/reports/storage/storage-by-group",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View storage rollup by grouping"
            },
        ],
        Component: StorageByBu,
        icon: "fa-chart-column",
    },
    {
        context: "Storage",
        title: "Free Space by Group",
        path: "/reports/storage/free-space-by-group",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View free space by grouping"
            },
        ],
        Component: FreeSpaceBy,
        icon: "fa-chart-pie",
    },
    {
        context: "Storage",
        title: "Disk Type by Device",
        path: "/reports/storage/disk-type-by-device",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View disk type by device"
            },
        ],
        Component: DiskTypeBy,
        icon: "fa-chart-column",
    },
    {
        context: "Storage",
        title: "Snap / Replication Details",
        path: "/reports/storage/enterprise-snap",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View enterprise snap / replication details."
            }
        ],
        Component: EnterpriseSnap,
        icon: "fa-chart-column",
    },
    {
        context: "Storage",
        title: "Project Planning Details",
        path: "/reports/storage/planning-projects",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View details of all capacity plans in the storage context (enterprise, device, and pool level)."
            }
        ],
        Component: PlanningProjects,
        icon: "fa-notebook",
    },
    {
        context: "Storage",
        title: "Enterprise Capacity Plan",
        path: "/reports/storage/enterprise-capacity-plan",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Enterprise Capacity Plan",
                description: "View high-level capacity trend and use inputs to plan future capacity."
            }
        ],
        Component: EnterpriseCapacityPlan,
        icon: "fa-chart-user",
    },
];

export const deviceItems = [
    {
        context: "Device",
        title: "Device Summary",
        path: "/reports/storage/device/device-summary",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "A newly re-imagined view high-level summary of device information."
            },
        ],
        Component: DeviceSummaryV2,
        icon: "fa-chart-user",
    },
    {
        context: "Device",
        title: "Health Alerts",
        path: "/reports/storage/device/device-health",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device health details."
            },
        ],
        Component: DeviceHealth,
        icon: "fa-monitor-waveform",
    },
    {
        context: "Device",
        title: "Device Details",
        path: "/reports/storage/device/additional-details",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device additional details in tabular format."
            },
        ],
        Component: DeviceAdditionalDetails,
        icon: "fa-table",
    },
    {
        context: "Device",
        title: "Audit Report",
        path: "/reports/storage/device/audit-report",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "Pertinent device information including trends, and associated hosts and business units."
            },
        ],
        Component: AuditReport,
        icon: "fa-chart-user",
    },

    {
        context: "Device",
        title: "Physical Diagram",
        path: "/reports/storage/device/physical-diagram",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "Pertinent device information including trends, and associated hosts and business units."
            },
        ],
        Component: PhysicalDiagram,
        icon: "fa-disc-drive",
    },
    {
        context: "Device",
        title: "Storage Group Summary",
        path: "/reports/storage/device/storage-group-summary",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device storage group summary in tabular format."
            },
        ],
        Component: StorageGroupSummary,
        icon: "fa-table",
    },
    {
        context: "Device",
        title: "Device Trends",
        path: "/reports/storage/device/device-trends",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device trends, both storage and capacity, by node, volume, or pool."
            },
        ],
        Component: DeviceTrends,
        icon: "fa-chart-line",
    },
    {
        context: "Device",
        title: "Storage by Server by Type",
        path: "/reports/storage/device/storage-by-server-by-type",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device storage by server by type in tabular format."
            },
        ],
        Component: StorageServerType,
        icon: "fa-chart-bar",
    },
    {
        context: "Device",
        title: "Free Space by Disk Group",
        path: "/reports/storage/device/free-space-by-disk-group",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device free space by disk group by type in tabular format."
            },
        ],
        Component: FreeSpaceByDiskByType,
        icon: "fa-chart-pie",
    },
    {
        context: "Device",
        title: "Provisioning Report",
        path: "/reports/storage/device/provisioning-report",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device provisioning in chart format."
            },
        ],
        Component: ProvisioningReport,
        icon: "fa-chart-column",
    },
    {
        context: "Device",
        title: "Pool Capacity Plan",
        path: "/reports/storage/device/pool-capacity-plan",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View pool capacity trend and use inputs to plan future capacity."
            },
        ],
        Component: PoolCapacityPlan,
        icon: "fa-chart-user",
    },
    {
        context: "Device",
        title: "Device Capacity Plan",
        path: "/reports/storage/device/device-capacity-plan",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View device capacity trend and use inputs to plan future capacity."
            },
        ],
        Component: DeviceCapacityPlan,
        icon: "fa-chart-user",
    }
];

export const virtualItems = [
    {
        context: "Virtual",
        title: "Virtual Summary",
        path: "/reports/virtual/virtual-summary",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View high-level summary of virtual machine information."
            }
        ],
        Component: VirtualSummary,
        icon: "fa-chart-user",
    },
    {
        context: "Virtual",
        title: "All Units",
        path: "/reports/virtual/all-units",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View all units of virtualized devices. All clusters, datastores, hosts, and VMs."
            },
        ],
        Component: VirtualAllUnits,
        icon: "fa-table",
    },
    {
        context: "Virtual",
        title: "Virtual Environment",
        path: "/reports/virtual/virtual-environment",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View a top level overview of your virtual environment."
            },
        ],
        Component: VirtualEnvironment,
        icon: "fa-chart-tree-map",
    },
    {
        context: "Virtual",
        title: "Health Alerts",
        path: "/reports/virtual/virtual-alerts",
        icon: "fa-monitor-waveform",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View yellow and red Virtual Health Alerts in grid format."
            },
        ],
        Component: VirtualHealthAlerts,
    },
    {
        context: "Virtual",
        title: "Cluster Plans Summary",
        path: "/reports/virtual/virtual-cluster-planning-summary",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View all saved Cluster Plans and involved details."
            },
        ],
        Component: VirtualPlanningSummary,
    },
    {
        context: "Virtual",
        title: "Orphaned VMDKs",
        path: "/reports/virtual/virtual-orphaned-vmdks",
        icon: "fa-monitor-waveform",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View Orphaned VMDKs alerts / VMDKs without VMs associated with it."
            },
        ],
        Component: VirtualOrphanedVMDKs,
    },
    {
        context: "Virtual",
        title: "VM Datastore Mapping",
        path: "/reports/virtual/virtual-datastore-mapping",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View VMs mapped to datastores."
            }
        ],
        Component: VirtualDatastoreMapping,
        icon: "fa-table",
    },
    {
        context: "Virtual",
        title: "Virtual Trends",
        path: "/reports/virtual/virtual-trends",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View capacity trends at the virtual level."
            },
        ],
        Component: VirtualTrends2,
    },
    {
        context: "Virtual",
        title: "Cluster Migration Modeling",
        path: "/reports/virtual/cluster-migration-modeling",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "Model changes when moving VMWare clusters to different data centers or resource groups."
            },
        ],
        Component: ClusterMigrationModeler,
    },
    {
        context: "Virtual",
        title: "Delta Report",
        path: "/reports/virtual/delta-report",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "See differences in growth and performance."
            },
        ],
        Component: DeltaReport,
    },
];

export const virtualHostItems = [
    {
        context: "ESX Host",
        title: "ESX Host Summary",
        path: "/reports/virtual/host/host-summary",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View a summary of information in grid and trend graph format for a specific host."
            },
        ],
        Component: VirtualHostSummary,
    },
    {
        context: "ESX Host",
        title: "Datastore Capacity History",
        path: "/reports/virtual/host/datastore-capacity-history",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View trend chart of datastore capacity usage history by host."
            }
        ],
        Component: DatastoreCapacityHistory,
    }
];

export const virtualClusterItems = [
    {
        context: "Cluster",
        title: "Cluster Summary",
        path: "/reports/virtual/cluster/cluster-summary",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View a summarized overview of the selected cluster."
            },
        ],
        Component: ClusterSummary,
    },

    {
        context: "Cluster",
        title: "Cluster Trends",
        path: "/reports/virtual/cluster/cluster-trends",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View cluster trends over time."
            },
        ],
        Component: ClusterTrends,
    },
    {
        context: "Cluster",
        title: "Cluster Modeling",
        path: "/reports/virtual/cluster/cluster-modeling",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "Model adding and removing hosts to/from your cluster and create/modify a capacity plan."
            },
        ],
        Component: ClusterModeling,
    },
];
export const virtualVCenterItems = [
    {
        context: "Data Center",
        title: "Data Center Summary",
        path: "/reports/virtual/vcenter/data-center-summary",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View a summarized overview of the selected data center."
            },
        ],
        Component: DataCenterSummary,
    },
    // {
    //   context: "VCenter",
    //   title: "vCenter Detail",
    //   path: "/reports/virtual/vcenter/vcenter-detail",
    //   icon: "fa-table",
    //   layout: [
    //     {
    //       col: {
    //         xs: 12,
    //       },
    //       type: "description",
    //       title: "",
    //       description: "View a detailed overview of the selected VCenter."
    //     },
    //   ],
    //   Component: VCenterDetail,
    // },

];
export const virtualDatastoreItems = [
    {
        context: "Datastore",
        title: "Datastore Summary",
        path: "/reports/virtual/datastore/datastore-summary",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View a summarized overview of the selected datastore."
            },
        ],
        Component: DatastoreSummary,
    },

];

export const vmItems = [
    {
        context: "VM",
        title: "VM Summary",
        path: "/reports/virtual/vm/vm-summary",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View a summary of information in grid and trend graph format for a specific virtual machine."
            },
        ],
        Component: VMSummary,
    },

];

export const entHostItems = [
    {
        context: "Hosts",
        title: "Enterprise Host Summary",
        path: "/reports/hosts/host-summary",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View a summary of information in grid and graphs format for Enterprise hosts."
            }
        ],
        Component: EntHostSummary,
    },
    {
        context: "Hosts",
        title: "Host & Device Capacity Modeling",
        path: "/reports/hosts/host-device-capacity-modeling",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "Model changes when moving external hosts into different on premise devices."
            }
        ],
        Component: StorageHostDeviceCapacityModeling,
        icon: "fa-chart-user",
    },
    {
        context: "Hosts",
        title: "Host LUN List",
        path: "/reports/hosts/host-lun-list",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "Model changes when moving external hosts into different on premise devices."
            }
        ],
        Component: HostLunList,
        icon: "fa-table",
    },
];

export const hostItems = [
    {
        context: "Host",
        title: "Host Trends",
        path: "/reports/hosts/host/host-trends",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View performance and capacity trends at the host level."
            },
        ],
        Component: HostTrends,
    },
    {
        context: "Host",
        title: "Host Connected Switches",
        path: "/reports/hosts/host/host-connected-switches",
        icon: "fa-chart-network",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View connected switches for a specific host."
            },
        ],
        Component: HostConnectedSwitches,
    },
    {
        context: "Host",
        title: "Host LUN Performance",
        path: "/reports/hosts/host/host-lun-performance",
        icon: "fa-chart-mixed",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View detailed Host performance by LUN"
            },
        ],
        Component: HostLunPerformanceDetail,
    },
];

export const filesItems = [
    {
        context: "Files",
        title: "File Trends",
        path: "/reports/file-analysis/file-trends",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View trends across file enterprise."
            }
        ],
        Component: FileTrends,
    },
    {
        context: "Files",
        title: "File Savings",
        path: "/reports/file-analysis/file-savings",
        icon: "fa-chart-radar",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View savings across file enterprise"
            }
        ],
        Component: FileSavings,
    },
    {
        context: "Files",
        title: "File by Last Used Date",
        path: "/reports/file-analysis/file-by-last-used-date",
        icon: "fa-chart-scatter",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View files from the last date they were accessed"
            }
        ],
        Component: FilesByLastUsed,
    },
];

export const switchesItems = [
    {
        context: "SAN-Switch",
        title: "Enterprise Switch Summary",
        path: "/reports/san-switch/enterprise-switch-summary",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View high level enterprise switch summary."
            },
        ],
        Component: SwitchesSummary,
    },
    {
        context: "SAN-Switch",
        title: "Switch Topology",
        path: "/reports/san-switch/switch-topology",
        icon: "fa-chart-network",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View topological overview of device connection."
            },
        ],
        Component: SwitchTopology,
    },
    {
        context: "SAN-Switch",
        title: "Switch Health Alerts",
        path: "/reports/san-switch/enterprise-switch-alerts",
        icon: "fa-monitor-waveform",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View yellow and red Enterprise Switch Health Alerts in grid format."
            },
        ],
        Component: EnterpriseSwitchHealthAlerts,
    },
]

export const switchItems = [
    {
        context: "Switch",
        title: "Switch Summary",
        path: "/reports/san-switch/switch/switch-summary",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "Switch Summary."
            },
        ],
        Component: SwitchSummary,
    },
    {
        context: "Switch",
        title: "ISL Port Analysis",
        path: "/reports/san-switch/switch/isl-port-analysis",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "ISL port Analysis."
            },
        ],
        Component: ISLPortAnalysis,
    },
    {
        context: "Switch",
        title: "Switch SAN Port Error Trend",
        path: "/reports/san-switch/switch/port-error-trend",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View switch level SAN Port error trends."
            },
        ],
        Component: SanPortErrorTrend,
    },
    {
        context: "Switch",
        title: "Switch Zone Detail",
        path: "/reports/san-switch/switch/zone-detail",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View switch level Zone details."
            },
        ],
        Component: SwitchZoneDetail,
    },
    {
        context: "Switch",
        title: "SAN Port Detail",
        path: "/reports/san-switch/switch/san-port-detail",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View switch port details."
            },
        ],
        Component: SANPortDetail,
    },
    {
        context: "Switch",
        title: "SAN Port Connectivity",
        path: "/reports/san-switch/switch/port-connectivity",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "ISL port Analysis."
            },
        ],
        Component: PortConnectivity,
    },
]

export const cloudItems = [
    {
        context: "Cloud",
        title: "Cloud Summary",
        path: "/reports/cloud/cloud-summary",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View storage rollup"
            },
        ],
        Component: CloudSummary,
        icon: "fa-chart-user",
    },
    {
        context: "Cloud",
        title: "All Units",
        path: "/reports/cloud/all-units",
        layout: [
            {
                col: {
                    xs: 12
                },
                type: "description",
                title: "",
                description: "View all units in your cloud infrastructure. All subscriptions, resource groups, compute resources, and storage accounts."
            },
        ],
        Component: CloudAllUnits,
        icon: "fa-table",
    },
    {
        context: "Cloud",
        title: "Budget/Spending Trend",
        path: "/reports/cloud/budget-spending-trend",
        icon: "fa-money-bill-trend-up",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cloud Budget Trend",
                description: "View spending vs budget trend in cloud."
            }
        ],
        Component: CloudBudgetTrend,
    },
    {
        context: "Cloud",
        title: "Cloud Trends",
        path: "/reports/cloud/cloud-trends",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cloud Trends",
                description: "View subscriptions trends in cloud."
            }
        ],
        Component: CloudTrends,
    },
    {
        context: "Cloud",
        title: "Growth Overview",
        path: "/reports/cloud/growth-overview",
        icon: "fa-chart-tree-map",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cloud Growth Overview",
                description: "View growth and service cost overview."
            }
        ],
        Component: CloudGrowthOverview,
    },
    {
        context: "Cloud",
        title: "Resource Group Forecast",
        path: "/reports/cloud/resource-group-forecast",
        icon: "fa-chart-area",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cloud Resource Group Forecast",
                description: "View cost and space forecasting by resource group."
            }
        ],
        Component: CloudResourceGroupForecast,
    },
    {
        context: "Cloud",
        title: "Resource Group Modeling",
        path: "/reports/cloud/resource-group-modeling",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cloud Resource Modeling",
                description: "Forecast cost, vCPU Used, Disk Used, Memory Used, and Total VMs on a monthly basis for a Resource Group in the cloud."
            }
        ],
        Component: CloudResourceModeling,
    },
    {
        context: "Cloud",
        title: "Health Alerts",
        path: "/reports/cloud/health-alerts",
        icon: "fa-monitor-waveform",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cloud Health Alerts",
                description: "View health alerts report."
            }
        ],
        Component: CloudHealthAlerts,
    },
    {
        context: "Cloud",
        title: "Cost Report",
        path: "/reports/cloud/cost-report",
        icon: "fa-chart-column",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cloud Cost Report",
                description: "View breakdown of Cloud Costs by Service."
            }
        ],
        Component: CloudCostReport,
    },
    {
        context: "Cloud",
        title: "Storage by Group",
        path: "/reports/cloud/storage-by-group",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "View storage rollup by grouping"
            },
        ],
        Component: CloudStorageByGroup,
        icon: "fa-chart-column",
    },
];

export const backupItems = [
    {
        context: "Backup",
        title: "Backup Runtime",
        path: "/reports/backup/backup-runtime",
        icon: "fa-chart-bar",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup Runtime",
                description: "View the variations in runtime for backups."
            }
        ],
        Component: BackupRuntime,
    },
    {
        context: "Backup",
        title: "Backup Status",
        path: "/reports/backup/backup-status",
        icon: "fa-chart-area",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup Status",
                description: "View the status of backups."
            }
        ],
        Component: BackupStatus,
    },
    {
        context: "Backup",
        title: "Backup Gap Analysis",
        path: "/reports/backup/backup-gap-analysis",
        icon: "fa-circle-notch",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup Gap Analysis",
                description: "View the Gap Analysis for Backups."
            }
        ],
        Component: BackupGapAnalysis,
    },
    {
        context: "Backup",
        title: "Backup Summary Trend",
        path: "/reports/backup/backup-trend",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup Summary Trend",
                description: "View the Enterprise level Backup trends."
            }
        ],
        Component: BackupTrend,
    },
    {
        context: "Backup",
        title: "Backup Pool Trend",
        path: "/reports/backup/backup-pool-trend",
        icon: "fa-chart-line",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup Pool Trend",
                description: "View the Pool level Backup trends."
            }
        ],
        Component: BackupPoolTrend,
    },
    {
        context: "Backup",
        title: "Backup Pool Summary",
        path: "/reports/backup/backup-pool-summary",
        icon: "fa-table",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup Pool Summary",
                description: "View the Summary of Backup Pools."
            }
        ],
        Component: BackupPoolSummary,
    },
    {
        context: "Backup",
        title: "Backup Host Occupancy",
        path: "/reports/backup/backup-host-occupancy",
        icon: "fa-chart-tree-map",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup Host Occupancy",
                description: "View the Backup Host Occupancy."
            }
        ],
        Component: BackupHostOccupancy,
    },
    {
        context: "Backup",
        title: "Backup VM Audit Report",
        path: "/reports/backup/backup-vm-audit-report",
        icon: "fa-chart-user",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Backup VM Audit Report",
                description: "View the Summary of Backup Pools."
            }
        ],
        Component: BackupVmAuditReport,
    },
];

export const databaseItems = [
    {
        context: "Database",
        title: "Enterprise Database Summary",
        path: "/reports/database/enterprise-database-summary",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Enterprise Database Summary",
                description: "View high-level summary of database information."
            }
        ],
        Component: EnterpriseDatabaseSummary,
        icon: "fa-chart-user",
    },
    {
        context: "Database",
        title: "Database Instances",
        path: "/reports/database/database-instances",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Database All Instances",
                description: "View all database instances."
            }
        ],
        Component: DatabaseInstances,
        icon: "fa-table",
    },
    {
        context: "Database",
        title: "Database Versions",
        path: "/reports/database/database-versions",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Database Versions",
                description: "View database versions."
            }
        ],
        Component: DatabaseVersions,
        icon: "fa-code-branch",
    },
    {
        context: "Database",
        title: "Database Health Alerts",
        path: "/reports/database/database-health-alerts",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Database Health Alerts",
                description: "View database health alerts."
            }
        ],
        Component: DatabaseHealthAlerts,
        icon: "fa-monitor-waveform"
    },
    {
        context: "Database",
        title: "Database Missing Indexes",
        path: "/reports/database/database-missing-indexes",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Database Missing Indexes",
                description: "View database missing indexes."
            }
        ],
        Component: DatabaseMissingIndexes,
        icon: "fa-clipboard-question"
    },
    {
        context: "Database",
        title: "Database Unused Indexes",
        path: "/reports/database/database-unused-indexes",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Database Unused Indexes",
                description: "View database unused indexes."
            }
        ],
        Component: DatabaseUnusedIndexes,
        icon: "fa-table",
    },
    {
        context: "Database",
        title: "Database Queries Performance",
        path: "/reports/database/database-queries-performance",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Database Queries Performance",
                description: "View database Queries Performance."
            }
        ],
        Component: DatabaseQueriesPerformance,
        icon: "fa-cogs",
    },
    {
        context: "Database",
        title: "Database Fragmentation",
        path: "/reports/database/database-fragmentation",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Database Fragmentation",
                description: "View database fragmentation."
            }
        ],
        Component: DatabaseFragmentation,
        icon: "fa-cogs",
    },
];

export const databaseServerItems = [
    {
        context: "Server",
        title: "Database Instance Detail",
        path: "/reports/database/server/database-instance-detail",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Enterprise Database Instances Detail",
                description: "View detailed information on a chosen database instance."
            }
        ],
        Component: DatabaseIntanceDetail,
        icon: "fa-chart-user",
    },
    {
        context: "Server",
        title: "Database Server Trends",
        path: "/reports/database/server/database-server-trend",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "Database server trend."
            },
        ],
        Component: DatabaseServerTrend,
    },
    {
        context: "Server",
        title: "Database Server Capacity Plan",
        path: "/reports/database/server/database-server-capacity-plan",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "",
                description: "Plan capacity at the database server instance level."
            },
        ],
        Component: DatabaseServerCapacityPlan,
        icon: "fa-chart-user"
    },
];

export const securityItems = [
    {
        context: "Security",
        title: "Security Dashboard",
        path: "/reports/security/security-dashboard",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Security Dashboard",
                description: "View high-level security information."
            }
        ],
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: SecurityDashboard,
        icon: "fa-table-columns",
    },
    {
        context: "Security",
        title: "Administrative Report",
        path: "/reports/security/administrative-report",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Administrative Report",
                description: "View user, login, and device activity."
            }
        ],
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: AdministrativeReport,
        icon: "fa-table",
    },
];

export const kubernetesItems = [
    {
        context: "Kubernetes",
        title: "Budgeting Report",
        path: "/reports/kubernetes/budgeting-report",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Budgeting Report",
                description: "View overview of Kubernetes budgeting information."
            }
        ],
        Component: KubernetesBudgetingReport,
        icon: "fa-money-bill-trend-up",
    },
    {
        context: "Kubernetes",
        title: "All Units",
        path: "/reports/kubernetes/all-units",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "All Units",
                description: "View all units of the kubernetes devices. All clusters, nodes, pods, and containers."
            }
        ],
        Component: KubernetesAllUnits,
        icon: "fa-table",
    },
    {
        context: "Kubernetes",
        title: "Capacity Planning",
        path: "/reports/kubernetes/capacity-planning",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Capacity Planning",
                description: "View trend forecasts for clusters, pods, containers, or nodes."
            }
        ],
        Component: KubernetesCapacityPlan,
        icon: "fa-chart-line",
    }
];

export const kubernetesClusterItems = [
    {
        context: "Kubernetes",
        title: "Cluster Overview",
        path: "/reports/kubernetes/cluster/cluster-overview",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Cluster Overview",
                description: "View Kubernetes overview."
            }
        ],
        Component: KubernetesClusterOverview,
        icon: "fa-chart-user",
    },
];

export const kubernetesNodeItems = [
    {
        context: "Kubernetes",
        title: "Node Status",
        path: "/reports/kubernetes/node/node-status",
        layout: [
            {
                col: {
                    xs: 12,
                },
                type: "description",
                title: "Node Status",
                description: "View node overview information."
            }
        ],
        Component: KubernetesNodeStatus,
        icon: "fa-chart-user",
    }
];

export const menuItems = [
    {
        context: "Home",
        title: "Home",
        icon: "fa-house",
        path: "/home",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Home,
        items: [],
    },
    {
        context: "Storage",
        title: "Storage",
        icon: "fa-disc-drive",
        path: "/reports/storage",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Storage,
        items: storageItems,
    },
    {
        context: "FinOps",
        title: "FinOps",
        icon: "fa-brands fa-square-dollar",
        path: "/reports/finops",
        beta: true,
        Component: FinOpsReports,
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        items: finOpsItems,
    },
    {
        context: "Business Unit",
        title: "Executive Reports",
        icon: "fa-brands fa-briefcase",
        path: "/reports/business-unit",
        Component: ExecutiveReports,
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        items: buItems,
    },
    {
        context: "Hosts",
        title: "Hosts",
        icon: "fa-server",
        path: "/reports/host",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Hosts,
        items: entHostItems,
    },
    {
        context: "File Analysis",
        title: "Files",
        icon: "fa-folder-tree",
        path: "/reports/file-analysis",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Files,
        items: filesItems,
    },
    {
        context: "Virtual",
        title: "Virtual",
        icon: "fa-network-wired",
        path: "/reports/virtual",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Virtual,
        items: virtualItems,
    },
    {
        context: "Backup",
        title: "Backup",
        icon: "fa-laptop-file",
        path: "/reports/backup",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Backup,
        items: backupItems,
    },
    {
        context: "SAN-Switch",
        title: "Switches",
        icon: "fa-ethernet",
        path: "/reports/san-switch",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Switches,
        items: switchesItems,
    },
    {
        context: "Databases",
        title: "Databases",
        icon: "fa-database",
        path: "/reports/database",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Databases,
        items: databaseItems,
    },
    {
        context: "Cloud",
        title: "Cloud",
        icon: "fa-cloud",
        path: "/reports/cloud",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Cloud,
        items: cloudItems,
    },
    {
        context: "Security",
        title: "Security",
        icon: "fa-lock",
        path: "/reports/security",
        roles: ["super_user", "super_user_read_only", "local_admin"],
        Component: Security,
        items: securityItems,
    },
    {
        context: "Kubernetes",
        title: "Kubernetes",
        icon: "fa-dharmachakra",
        path: "/reports/kubernetes",
        roles: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
        Component: Kubernetes,
        items: kubernetesItems,
    },
];


export const allRoutes = [
    ...menuItems,
    ...storageItems,
    ...virtualItems,
    ...utilItems,
    ...settingsItems,
    ...adminItems,
    ...deviceItems,
    ...virtualHostItems,
    ...virtualClusterItems,
    ...virtualDatastoreItems,
    ...vmItems,
    ...hostItems,
    ...entHostItems,
    ...filesItems,
    ...drillDownItems,
    ...autobotItems,
    ...buItems,
    ...finOpsItems,
    ...switchesItems,
    ...switchItems,
    ...cloudItems,
    ...backupItems,
    ...virtualVCenterItems,
    ...databaseItems,
    ...databaseServerItems,
    ...securityItems,
    ...kubernetesItems,
    ...kubernetesClusterItems,
    ...kubernetesNodeItems
];
